export default class FirebaseSnapshots {
  constructor() {
    this.registeredSnapshotUnsubscribers = [];
  }

  register(unsubscribe, unsubscribeId) {
    const i = this.registeredSnapshotUnsubscribers.findIndex(({ id }) => id === unsubscribeId);
    if (i <= -1) {
      this.registeredSnapshotUnsubscribers.push({ unsubscribe, id: unsubscribeId });
    } else {
      this.registeredSnapshotUnsubscribers[i].unsubscribe();
      this.registeredSnapshotUnsubscribers[i] = { unsubscribe, id: unsubscribeId };
    }
  }

  unregister(unsubscribeId) {
    const i = this.registeredSnapshotUnsubscribers.findIndex(({ id }) => id === unsubscribeId);
    if (i > -1) {
      this.registeredSnapshotUnsubscribers[i].unsubscribe();
      this.registeredSnapshotUnsubscribers.splice(i, 1);
    }
  }

  unsubscribeAll() {
    this.registeredSnapshotUnsubscribers.forEach(({ unsubscribe }) => unsubscribe());
  }
}
